import styled from "styled-components";

export const Container = styled.div`
    min-height: 100vh;
    background: #f6f3ec;

    .container-fluid,
    .row {
        margin: 0;
        min-height: 100vh;
    }

    .col-md-6 {
        padding: 0;
    }

    .left-content {
        position: relative;
        min-height: 100vh;
        background: #516274;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 96px 28px 48px;
    }

    .btn-back {
        top: 28px;
        left: 28px;

        button {
            height: 42px;
            padding: 0 16px;
            border: 1px solid rgba(255, 255, 255, 0.28);
            border-radius: 999px;
            background: rgba(255, 255, 255, 0.08);
            color: #fff;
            box-shadow: none;
        }

        button:hover {
            background: rgba(255, 255, 255, 0.16);
        }
    }

    .login-container {
        width: min(440px, 100%);
    }

    .title-content {
        margin: 0;
        color: #fff;
        font-size: 40px;
        font-weight: 700;
        line-height: 1.1;
        letter-spacing: -0.04em;
        text-align: center;
    }

    .subtitle {
        margin: 10px 0 22px;
        color: rgba(255, 255, 255, 0.78);
        font-size: 16px;
        line-height: 1.5;
        text-align: center;
    }

    .login {
        padding: 28px 28px 22px;
        background: #fff;
        border-radius: 28px;
        box-shadow: 0 24px 60px rgba(20, 28, 36, 0.28);

        .title {
            color: #2f3d4b;
            font-size: 22px;
            font-weight: 700;
            line-height: 1.2;
            letter-spacing: -0.03em;
        }

        .type-users {
            position: relative;
            display: flex;
            align-items: center;
            width: 100%;
            height: 48px;
            margin: 18px 0 8px;
            padding: 4px;
            border: 0;
            border-radius: 999px;
            background: #eef2f5;

            .type {
                z-index: 1;
                flex: 1;
                height: 40px;
                margin: 0;
                padding: 0 8px;
                border: 0;
                border-radius: 999px;
                background: transparent;
                color: #516274;
                font-size: 14px;
                font-weight: 700;
                line-height: 40px;
                text-align: center;
                cursor: pointer;
                appearance: none;
                box-shadow: none;
            }

            .type.selected {
                color: #2f3d4b;
            }

            .bg-type {
                position: absolute;
                top: 4px;
                z-index: 0;
                pointer-events: none;
                height: 40px;
                border-radius: 999px;
                background: #f4c600;
                box-shadow: 0 8px 16px rgba(81, 98, 116, 0.16);
                transition: left 0.25s ease, width 0.25s ease;

                &.user.active {
                    left: 4px;
                    width: calc(50% - 6px);
                }

                &.admin.active {
                    left: 50%;
                    width: calc(50% - 6px);
                }
            }
        }

        .form .field {
            position: relative;
            margin: 16px 0 0;
            text-align: left;
        }

        .form .field > label {
            margin-bottom: 8px;
            color: #516274 !important;
            font-size: 13px;
            font-weight: 700;
        }

        .form input {
            width: 100%;
            height: 50px;
            padding: 0 16px;
            border: 1px solid rgba(81, 98, 116, 0.22);
            border-radius: 14px;
            background: #fbfcfd;
            color: #2f3d4b;
            font-size: 15px;
        }

        .form .field .ui.input:has(.img-icon) input {
            padding-right: 44px;
        }

        .form input:focus {
            outline: none;
            border-color: #f4c600;
            box-shadow: 0 0 0 4px rgba(244, 198, 0, 0.28);
        }

        .form input.error {
            border-color: #b3261e;
        }

        .form .field .ui.input {
            position: relative;
        }

        .form .field .ui.input .img-icon {
            position: absolute;
            top: 50%;
            right: 12px;
            bottom: auto;
            left: auto;
            display: flex;
            align-items: center;
            justify-content: center;
            width: 24px;
            height: 24px;
            margin: 0;
            padding: 0;
            border: 0;
            border-radius: 0;
            outline: none;
            box-shadow: none;
            appearance: none;
            background: transparent;
            color: #516274;
            line-height: 0;
            transform: translateY(-50%);
            cursor: pointer;
        }

        .form .field .ui.input .img-icon:focus,
        .form .field .ui.input .img-icon:focus-visible,
        .form .field .ui.input .img-icon:active {
            outline: none;
            border: 0;
            box-shadow: none;
            background: transparent;
        }

        .img-icon svg {
            color: #516274;
            stroke: #516274;
        }

        .field-error-msg {
            margin: 6px 0 0 !important;
            color: #b3261e;
            font-size: 12px;
            text-align: left;
        }

        .btn-submit {
            width: 100%;
            height: 50px;
            margin: 22px 0 4px;
            border-radius: 999px;
            color: #3a3320;
            font-size: 15px;
            font-weight: 700;
            box-shadow: 0 10px 20px rgba(244, 198, 0, 0.28);
        }

        .btn-submit:hover {
            background: #e0b500;
        }

        .btn-forget {
            width: 100%;
            height: 40px;
            color: #516274;
            font-weight: 600;
            box-shadow: none;
        }

        .btn-forget:hover {
            color: #2f3d4b;
        }
    }

    .stage {
        background: #f6f3ec;
    }

    .right-content {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        min-height: 100vh;
        padding: 40px 32px 32px;
        gap: 8px;
    }

    .map {
        width: min(460px, 86%);
        height: auto;
        max-height: 68vh;
        object-fit: contain;
        filter: drop-shadow(0 18px 30px rgba(81, 98, 116, 0.16));
    }

    .brand {
        width: 118px;
        height: auto;
        margin-top: 8px;
    }

    @media (max-width: 767.98px) {
        .left-content,
        .right-content {
            min-height: auto;
        }

        .left-content {
            padding: 92px 18px 36px;
        }

        .title-content {
            font-size: 32px;
        }

        .login {
            padding: 22px 18px 16px;
        }

        .right-content {
            padding: 12px 18px 36px;
        }

        .map {
            max-height: 46vh;
        }
    }
`
